// extracted by mini-css-extract-plugin
module.exports = {"container":"CapustaTitle_container_34-yy","icon":"CapustaTitle_icon_3WS-x","title":"CapustaTitle_title_3zRk2"};